define('customPlugins/atnAutoRefocus',[
        'knockout', 'lodash'
    ],
    function(ko, _) {
        'use strict';
        
        ko.bindingHandlers.atnAutoRefocus = {
            update: function(element, valueAccessor) {
                ko.utils.unwrapObservable(valueAccessor());
                _.defer(function() {
                    element.focus();
                });
            }
        };        
    });
